import dayjs from "dayjs";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import {
  GROUP_DETAIL_LABEL,
  GROUP_NEXT_SESSION_DATE_FORMAT,
} from "../group-visit-constant";
import { GroupDetail } from "../group-visit-types";
import DetailCard from "./DetailCard";

export type NextSessionCardProps = {
  group: GroupDetail;
};

const SESSION_FONT_SIZE = "18px";

/**
 * @author Rajkumar Rathod
 */
const NextSessionCard = ({ group }: NextSessionCardProps) => {
  const { startTime, locationName, enrolledPatients } = group.nextSession ?? {};

  return (
    <DetailCard bgcolor={CHART_COLORS.surfaceSubtle}>
      <Flex flexDirection="column" gap={0.5}>
        <Text
          {...CHART_TYPOGRAPHY.body5}
          c={CHART_COLORS.textMutedGrey}
          textTransform="uppercase"
          letterSpacing="0.04em"
        >
          {GROUP_DETAIL_LABEL.nextSession}
        </Text>

        {startTime ? (
          <>
            <Text
              size={SESSION_FONT_SIZE}
              fontWeight={CHART_TYPOGRAPHY.weight.medium}
              c={CHART_COLORS.textDarker}
            >
              {dayjs(startTime).format(GROUP_NEXT_SESSION_DATE_FORMAT)}
            </Text>
            {!!locationName && (
              <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
                {locationName}
              </Text>
            )}
            <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
              {GROUP_DETAIL_LABEL.enrolledPatients(enrolledPatients ?? 0)}
            </Text>
          </>
        ) : (
          <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
            {GROUP_DETAIL_LABEL.noNextSession}
          </Text>
        )}
      </Flex>
    </DetailCard>
  );
};

export default NextSessionCard;
